<div class="container-fluid">
  <page-header-search
    [isSearchInput]="true"
    [pageTitleValue]="pageTitle"
    [placeholderValue]="placeholder"
    (onHeaderSearchSubmit)="onSearchBranch($event)"
  ></page-header-search>

  <div *ngIf="filteredBranches?.length" class="card">
    <div class="card-body">
      <div class="table-title">
        <h3 class="title mb-0">All Branches</h3>
        <a (click)="invertSorting()">
          <span>↑</span>
          <span class="ml--1">↓</span>
          Sort By
        </a>
      </div>
      <div class="table-responsive">
        <table class="table align-items-center table-flush">
          <thead class="thead-light">
            <tr>
              <th *ngFor="let th of theadArray">{{ th | uppercase }}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="pointer" *ngFor="let item of filteredBranches">
              <td>
                <span>{{ item.name }}</span>
              </td>
              <td>
                <span>{{ item.arName }}</span>
              </td>
              <td>
                <span>{{ item.phone }}</span>
              </td>
              <td>
                <span>{{ item.email }}</span>
              </td>
              <td>
                <span>{{ item.area?.name }}</span>
              </td>
              <td>
                <span>{{ item.city?.name }}</span>
              </td>
              <td>
                <span>{{ item.address }}</span>
              </td>
              <td>
                <span>{{ item.arAddress }}</span>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <label class="custom-toggle custom-toggle-default">
                    <input
                      [checked]="item.isActive"
                      type="checkbox"
                      id="active-check"
                      (change)="onBranchActiveChange($event, item)"
                    />
                    <span
                      class="custom-toggle-slider rounded-circle"
                      data-label-off="No"
                      data-label-on="Yes"
                    >
                    </span>
                  </label>
                </div>
              </td>
              <td>
                <button
                  class="btn btn-icon btn-outline-success mr-2"
                  type="button"
                  placement="top"
                  tooltip="Edit"
                  [routerLink]="['edit', item.id]"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-edit"> </i>
                  </span>
                </button>
                <button
                  class="btn btn-icon btn-outline-warning mr-2"
                  type="button"
                  placement="top"
                  tooltip="Delete"
                  (click)="onDeleteBranch($event, item)"
                >
                  <span class="btn-inner--icon">
                    <i class="fa fa-trash"> </i>
                  </span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="fab-btn" [routerLink]="'add'">
  <i class="ni ni-fat-add"></i>
</div>
